@if (!onlyShowModal) {
    <div class="login-page" data-uiid="login-page">
        <div class="login-block">
            <div class="login-submodules">
                <ng-container *ngTemplateOutlet="loginModalTemplate"> </ng-container>

                <div class="login-illustration">
                    <cerrix-animated-illustration></cerrix-animated-illustration>
                </div>
            </div>

            <div class="login-block-bottom-shape"></div>
        </div>

        <div class="copyright-block">© CERRIX B.V. {{ currentYear }} - All Rights Reserved</div>
    </div>
} @else if (config) {
    <div class="centered-modal-container">
        <ng-container *ngTemplateOutlet="loginModalTemplate"> </ng-container>
    </div>
}

<ng-template #loginModalTemplate>
    @if (config) {
        <div class="login-modal">
            @if (showLoader) {
                <div class="loading-backdrop">
                    <div class="fancy-loader"></div>
                    @if (loaderMessage) {
                        <div class="loading-message">{{ loaderMessage }}</div>
                    }
                </div>
            }

            <div class="client-logo">
                <cerrix-logo
                    [width]="175"
                    [height]="35"
                    [retrieveLogo]="false"
                    [customerLogo]="config.customerLogo"
                ></cerrix-logo>
            </div>

            <div class="message-area">
                @if (warningMessage) {
                    <div data-uiid="login-warning-message" class="message warnings">
                        <span>{{ warningMessage }}</span>
                    </div>
                }
                @if (notificationMessage) {
                    <div class="message notifications">
                        <span>{{ notificationMessage }}</span>
                    </div>
                }
                @if (onlyShowModal) {
                    <div class="message notifications">
                        <span>Please log in to continue.</span>
                    </div>
                }
                @if (!warningMessage && forcedPasswordReset) {
                    <div class="message notifications">
                        This password has expired. Please enter a new password for this username.
                    </div>
                }
            </div>

            @switch (currentView) {
                @case (allViews.login) {
                    @if (config.formLoginEnabled) {
                        <div class="default-login">
                            <span class="default-login-text">Login to CERRIX</span>

                            <div class="input-group login-input">
                                <span>
                                    <i class="fa fa-user fa-fw fa-sm" aria-hidden="true"></i>
                                </span>
                                <input
                                    data-uiid="login-name"
                                    type="text"
                                    class="form-control"
                                    placeholder="Username"
                                    [(ngModel)]="username"
                                    id="login-username"
                                    autofocus
                                    inputTooltip
                                />
                            </div>

                            <div class="input-group login-input">
                                <span>
                                    <i class="fa fa-lock fa-fw fa-sm" aria-hidden="true"></i>
                                </span>
                                <input
                                    data-uiid="login-password"
                                    type="password"
                                    class="form-control"
                                    placeholder="Password"
                                    [(ngModel)]="password"
                                    id="login-password"
                                />
                            </div>

                            <button
                                class="btn login-page-button"
                                id="login-button"
                                data-uiid="login-button"
                                (click)="login()"
                            >
                                Login
                            </button>

                            @if (config.passwordResetEnabled) {
                                <div class="forgot-password clickable">
                                    <span (click)="setSecondaryPage(allViews.forgotPassword)"
                                        >Forgot password?</span
                                    >
                                </div>
                            }
                        </div>
                    }

                    @if (config.jwtExternalLoginEnabled) {
                        <div class="alternative-login">
                            <small class="alternative-msg">{{
                                !config.formLoginEnabled ? "Login with" : "Or login with"
                            }}</small>

                            <div class="work-login-button clickable" (click)="jwtExternalLogin()">
                                <span>Work account</span>
                                <i class="fa fa-chevron-right ms-3"></i>
                            </div>
                        </div>
                    }
                }
                @case (allViews.forgotPassword) {
                    <div class="forgot-password-control">
                        <span
                            class="return-to-login clickable"
                            (click)="currentView = allViews.login"
                        >
                            <i class="fas fa-chevron-left me-2"></i>Back to login
                        </span>

                        <div class="input-group login-input">
                            <span>
                                <i class="fa fa-user fa-fw fa-sm" aria-hidden="true"></i>
                            </span>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Username"
                                [(ngModel)]="username"
                                inputTooltip
                            />
                        </div>

                        <button class="btn login-page-button" (click)="resetPasswordRequest()">
                            Reset
                        </button>

                        <small class="text-muted mt-2">
                            If entered username exists, a password reset link will be sent within
                            moments. Use this link to reset your password.
                        </small>
                    </div>
                }
                @case (allViews.resetPassword) {
                    <div class="password-reset-control">
                        <span class="default-password-reset-text">Password reset</span>

                        <div class="input-group login-input">
                            <span>
                                <i class="fa fa-lock fa-fw fa-sm" aria-hidden="true"></i>
                            </span>
                            <input
                                type="password"
                                class="form-control"
                                placeholder="New password"
                                [(ngModel)]="newPassword"
                                autofocus
                            />
                        </div>

                        <div class="input-group login-input">
                            <span>
                                <i class="fa fa-lock fa-fw fa-sm" aria-hidden="true"></i>
                            </span>
                            <input
                                type="password"
                                class="form-control"
                                placeholder="Confirm new password"
                                [(ngModel)]="newPasswordConfirm"
                            />
                        </div>

                        <button class="btn login-page-button" (click)="saveNewPassword()">
                            Save password
                        </button>
                    </div>
                }
                @case (allViews.newLocation) {
                    <div class="new-location-control">
                        <span class="default-new-location-text">Verify your location</span>

                        <div class="input-group login-input">
                            <span>
                                <i class="fa fa-fingerprint fa-fw fa-sm" aria-hidden="true"></i>
                            </span>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Verification code"
                                [(ngModel)]="locationVerificationCode"
                                maxlength="5"
                                autofocus
                            />
                        </div>

                        <button class="btn login-page-button" (click)="verifyNewLocation()">
                            Verify code
                        </button>

                        <small class="text-muted mt-2">
                            You tried to login from a new location. Enter the code we sent to your
                            mail to continue login.
                        </small>
                    </div>
                }
            }
        </div>
    }
</ng-template>
